<template>
  <div
    name="termly-embed"
    :data-id="slice.primary.data_id"
  />
</template>

<script setup lang="ts">
import type { Content } from "@prismicio/client";

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
const props = defineProps(
  getSliceComponentProps<Content.TermlyPolicySlice>([
    "slice",
    "index",
    "slices",
    "context",
  ]),
);

useHead({
  // Script from Termly
  script: [{ src: "https://app.termly.io/embed-policy.min.js", defer: true }],
});
</script>
